import { render, staticRenderFns } from "./presentation-editor.vue?vue&type=template&id=4b52a6ce&scoped=true&"
import script from "./presentation-editor.vue?vue&type=script&lang=js&"
export * from "./presentation-editor.vue?vue&type=script&lang=js&"
import style0 from "./presentation-editor.vue?vue&type=style&index=0&id=4b52a6ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52a6ce",
  null
  
)

export default component.exports